import { uniq } from "lodash-es";
import React, { FC, SyntheticEvent } from "react";

import Autocomplete from "../../../../components/styled/Autocomplete";
import TextField from "../../../../components/styled/TextField";
import { useSelector } from "../../../../store";
import { useListServiceAccountsQuery } from "../../../../store/pomeriumApi";

type UserIDSelectorProps = {
  readonly: boolean;
  id: string;
  value: string;
  onChange: (value: string) => void;
};

const UserIDSelector: FC<UserIDSelectorProps> = ({
  readonly,
  id,
  value,
  onChange,
}) => {
  const { clusterId, organizationId } = useSelector((state) => state.current);
  const { data: serviceAccounts } = useListServiceAccountsQuery(
    {
      organizationId,
      clusterId,
    },
    { skip: !organizationId || !clusterId },
  );

  const options: string[] = uniq(
    serviceAccounts
      ?.map((sa) => sa.userId)
      ?.filter((id) => !!id)
      ?.filter((id) => id.indexOf(value) >= 0)
      ?.sort() || [],
  );

  function onSelectedChange(_event: SyntheticEvent, newValue: unknown) {
    onChange(`${newValue || ""}`);
  }

  function onInputChange(_event: SyntheticEvent, newValue: string) {
    onChange(`${newValue || ""}`);
  }

  return (
    <Autocomplete
      id={id}
      freeSolo
      disableClearable
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Value"
          name={id}
          inputProps={{
            ...params.inputProps,
            type: "search",
          }}
        />
      )}
      value={value}
      onChange={onSelectedChange}
      inputValue={value}
      onInputChange={onInputChange}
      disabled={readonly}
    />
  );
};

export default UserIDSelector;
